<template>
  <div class="myGrades">
    <van-nav-bar class="page_nav" title="我的成绩" left-arrow @click-left="onClickLeft" :fixed="true" />
    <div class="placeholder_box" style="height:46PX"></div>
    <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        :immediate-check="false"
        ref="list"
        @load="onLoad"
        v-show="gradesList && gradesList.length"
      >
      <div class="grade_item" v-for="item in gradesList" :key="item.ucode" @click="$router.push('/gradeDetail?ucode='+item.planUcode+'&certName='+item.certName)">
          <p class="tb_title">{{item.certName}}</p>
         <van-icon name="arrow" class="right_arr" color="#666666" size="10" />
      </div>
    </van-list>
    <div class="noContent" v-if="!gradesList.length">
        <p class="trainging-noContent">暂无数据~</p>
    </div>

  </div>
</template>

<script>
export default {
  name: "myGrades",
  data() {
    return {
      pageNum: 1,
      pageSize: 10,
      loading: false,
      finished: false,
      gradesList: []
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    getData() {
      this.$api.rensheDistributionExam
        .getMyCertList({ pageNum: this.pageNum, pageSize: this.pageSize })
        .then(res => {
          if (res.data && res.data.list) {
            this.gradesList = this.gradesList.concat(res.data.list);
            // this.total = res.data.total;
            // 加载状态结束
            this.loading = false;
            // 数据全部加载完成
            this.finished = res.data.isLastPage;
            // if (
            //       this.gradesList.length == res.data.total ||
            //       !res.data.list ||
            //       res.data.list.length == 0
            //   ) {
            //       // this.error = false;
            //       this.finished = true;
            //   }
          }
        });
    },
    onLoad() {
      this.pageNum ++;
      this.getData();
    }
  }
};
</script>

<style scoped lang="stylus">
.myGrades {
  min-height: 100vh;
  background: #F8F9FA;
  padding-bottom: 40px;
  box-sizing: border-box;
}

.page_nav {
  position: fixed;
}

.grade_item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 690px;
  height: 120px;
  background: #FFFFFF;
  border-radius: 14px;
  margin: 16px auto;
  padding: 32px 24px;
  box-sizing: border-box;

  .tb_title {
    font-size: 30px;
    color: #333;
    line-height: 42px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .right_arr {
    margin-left: 58px;
  }
}

.noContent {
  text-align: center;
  padding-top: 26%;

  img {
    width: 484px;
    height: 300px;
  }

  .trainging-noContent {
    color: #999999;
    font-size: 28px;
    font-weight: 400;
    margin-top: 16px;
    line-height: 40px;
    font-family: PingFangSC-Regular, PingFang SC;
  }
}
</style>
